module.exports = __webpack_public_path__ + "image/model-logo_1.1782790484418.png";